import React from "react";
import { MainContainer } from "./styles";
import { ItemMenuProps } from "./types";
import Typography from "../../../../../components/Typography";
import ThemeColors from "../../../../../themes/colors";

const ItemMenu: React.FC<ItemMenuProps> = ({
  icon,
  title,
  id,
  isSelected,
  onSelectItem,
}): JSX.Element => {
  return (
    <MainContainer selected={isSelected} onClick={() => onSelectItem(id)}>
      {React.cloneElement(icon, {
        color: isSelected ? ThemeColors.Purple500 : ThemeColors.Black400,
        size: 20,
      })}
      <Typography text={title} color={isSelected ? "Purple500" : "Black400"} weight={isSelected ? 600 : 400} />
    </MainContainer>
  );
};

export default ItemMenu;
